import type { Comment } from "@/mocks/comments";
import CommentCard from "@/components/base/CommentCard";

interface CommentSectionProps {
  comments: Comment[];
  label: string;
  title1: string;
  title2: string;
}

export default function CommentSection({
  comments,
  label,
  title1,
  title2,
}: CommentSectionProps) {
  const columns = distributeColumns(comments, 3);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-sm font-medium mb-4">
            {label}
          </span>
          <h2 className="font-serif font-bold text-3xl md:text-4xl text-foreground-950 leading-tight">
            {title1}
            <br />
            {title2}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {columns.map((col, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-5">
              {col.map((comment) => (
                <CommentCard key={comment.id} comment={comment} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function distributeColumns<T>(items: T[], numColumns: number): T[][] {
  const cols: T[][] = Array.from({ length: numColumns }, () => []);
  items.forEach((item, idx) => {
    cols[idx % numColumns].push(item);
  });
  return cols;
}